import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class SiteModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (SiteModel._instance == null) SiteModel._instance = new SiteModel(authManager);
        return SiteModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'sites/sites', 'sites/sites/codelist');

        this.entityName = 'sites.Site';
        this.privileges = {
            create: [["adminSites"]],
            read: [["adminSites"],["manageSites"],["editSites"],["readSites"]],
            update: [["adminSites"]],
            delete: [["adminSites"]],
        };

        this.label = 'Site';
        this.setLabel = 'Sites';

        this.browser = {
            name: 'default-sites-site-browser',
            moduleName: 'default-sites-site-browser',
            moduleTitle: 'Sites',
            moduleStateSlotName: 'default-sites-site-browser',
        };

        this.editor = {
            name: 'default-sites-site-editor',
            moduleName: 'default-sites-site-editor',
            moduleTitle: 'Site',
            moduleStateSlotName: 'default-sites-site-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'projectId',
                type: 'Project',
                persistent: true,
                label: 'Project',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'projectLabel',
                type: 'string',
                persistent: false,
                label: 'Project',
                readOnly: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'workingFolderId',
                type: 'Folder',
                persistent: true,
                label: 'Working Folder',
            },
            {
                name: 'mapUrl',
                type: 'string',
                persistent: true,
                label: 'Map URL',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'mapFileId',
                type: 'File',
                persistent: true,
                label: 'Map File',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'timeZoneId',
                type: 'TimeZone',
                persistent: true,
                label: 'Time Zone',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'timeZoneLabel',
                type: 'string',
                persistent: false,
                label: 'Time Zone',
                distinctLabel: 'Time Zone (text)',
                readOnly: true,
                inBrowser: true,
                filterable: true,
            },
            {
                name: 'timeZoneOffset',
                type: 'int',
                persistent: false,
                label: 'Time Zone Offset',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
            },
            {
                name: 'lengthUnitsId',
                type: 'Unit',
                persistent: true,
                label: 'Length Units',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'areaUnitsId',
                type: 'Unit',
                persistent: true,
                label: 'Area Units',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'durationUnitsId',
                type: 'Unit',
                persistent: true,
                label: 'Duration Units',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
            {
                name: 'createdAt',
                type: 'utc_datetime',
                persistent: true,
                label: 'Created At',
                readOnly: true,
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'createdById',
                type: 'User',
                persistent: true,
                label: 'Created By',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'createdByLabel',
                type: 'string',
                persistent: false,
                label: 'Created By',
                distinctLabel: 'Created By (Name)',
                readOnly: true,
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'updatedAt',
                type: 'utc_datetime',
                persistent: true,
                label: 'Changed At',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'updatedById',
                type: 'User',
                persistent: true,
                label: 'Changed By',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'updatedByLabel',
                type: 'string',
                persistent: false,
                label: 'Changed By',
                distinctLabel: 'Updated By (Name)',
                readOnly: true,
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'deletedAt',
                type: 'utc_datetime',
                persistent: true,
                label: 'Deleted At',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'deletedById',
                type: 'User',
                persistent: true,
                label: 'Deleted By',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'deletedByName',
                type: 'string',
                persistent: false,
                label: 'Deleted By',
                readOnly: true,
                inEditor: true,
                filterable: true,
                orderable: true,
            },
        ];

    }

}
